import {merge} from 'lodash-es';
import base from '@/i18n/en';
import menu from './menu';
import label from './label';

export default merge(base, {
    menu,
    label,
});
